import angular from "angular";
import { SubFilter, SubFilterScope } from "./subFilters";

export class OptionsFilter
  extends SubFilter {

  readonly options: { display: string; value?: any; }[];

  constructor(config: { displayName: string; queryFieldNames: string[]; options: { display: string, value: any }[], includeNullValue?: boolean }) {
    super(config)

    this.options = config.options
  }

  beforeActivate(params: { $scope: SubFilterScope }) {
    super.beforeActivate(params)

    const queryObject = this.gridFilter?.getQueryObject()
    if (!queryObject) {
      return
    }
    const queryField = this.queryFieldNames[0]
    const currentValue = queryObject[queryField]

    const selectedOption = this.options.find(opt => opt.value === currentValue)
    const selectedValue = (selectedOption === null || selectedOption === undefined) ? null : selectedOption.value
    queryObject[queryField] = selectedValue
  }

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`<select 
      title="${this.queryFieldNames[0]}-options-filter" 
      class="form-control" 
      ng-model="${this.getQueryFieldExpression()}"
      ng-model-options="gridFilterController.defaultModelOptions"
      ng-options="option.value as option.display for option in subFilterController.options track by option.value">
      <option value="">All</option>
    </select>
    `)
  }
}